import {default as colours} from 'styles/colours';

export const headerFontSizes = {
    1: 32,
    2: 24,
    3: 20,
    4: 16,
    5: 14,
    6: 12,
}

const buttonStyles = {
    fontFamily: 'inherit',
    padding: '6.5px 25px',
    cursor: 'pointer',
    borderRadius: 6,
    fontSize: 16,
    lineHeight: 1.25,
    border: 'none',
    marginBottom: 15,
    marginRight: 5,
};

export default {
    font: {
        main: {
            family: 'SourceSansPro, sans-serif',
            size: 14,
            colour: colours.font.main,
        },
    },
    background: {
        main: colours.background.main,
        panel: colours.background.panel,
    },
    button: {
        primary: {
            base: {
                ...buttonStyles,
                color: colours.font.contrast,
                backgroundColor: colours.background.button.primary.normal,
            },
            hover: {
                backgroundColor: colours.background.button.primary.hover,
            },
            focus: {
                outlineStyle: 'solid',
                outlineWidth: 2,
                outlineOffset: 2,
            },
        },
        secondary: {
            base: {
                ...buttonStyles,
                color: colours.font.default,
                backgroundColor: colours.background.button.secondary.normal,
            },
            hover: {
                backgroundColor: colours.background.button.secondary.hover,
            },
            focus: {
                outlineStyle: 'solid',
                outlineWidth: 2,
                outlineOffset: 2,
            },
        },
    },
    header: {
        display: 'flex',
        padding: '3px 25px',
        alignItems: 'center',
        gap: 10,

        transitionProperty: 'margin-top, margin-bottom',
        transitionDuration: '0.7s',
        transitionTimingFunction: 'ease-out',
    },
};